import {useCallback, useEffect} from "react";
import {isLoadingCommonFilters, rentalDates} from "@signals";
import { useSignal } from "@preact/signals-react";
import {formatDate, postSubmit} from "@ui-seeker/utils";
import { BACKEND_APIS } from "@constants";
import { useToast } from "@hooks";
import { europcarPricingEnvFilters } from "../@signals";

export default function useEuropcarPricingEnvTableData() {

    const tableData = useSignal([])

    const tableHeaders = useSignal([])
    const tableSubHeaders = useSignal([])
    const providers = useSignal([])
    const isLoading = useSignal(false)
    const { showToast } = useToast()

    const getTableData = useCallback(() => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.DASHBOARD}/results`, { ...europcarPricingEnvFilters.value, pickupDate: rentalDates.value.map(date => formatDate(date, { format: 'yyyyMMdd' })) })
            .then(({ results, headers, subHeaders, subRows }) => {
                isLoading.value = false
                tableData.value = results;
                tableHeaders.value = headers;
                tableSubHeaders.value = subHeaders;
                providers.value = subRows;
                isLoadingCommonFilters.value = false
            })
            .catch(() => {
            showToast.error("Server Error: Please try again later.")
        })
    }, [])

    useEffect(() => {
        if(isLoadingCommonFilters.value) getTableData()
    }, [isLoadingCommonFilters.value]);


    return {
        isLoading: isLoading.value,
        tableData: tableData.value,
        tableHeaders: tableHeaders.value,
        tableSubHeaders: tableSubHeaders.value,
        providers: providers.value
    }
}